import styled, { css } from "styled-components";
import { Row } from "components/bootstrap";
const WarningRow = styled(Row)(
  ({ theme }) => css`
    border-color: ${theme.colors.variant.warning};
  `
);
export default WarningRow;
